import React from 'react';

interface Tab {
  id: string;
  label: string;
}

interface ContentAreaProps {
  title: string;
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  children?: React.ReactNode;
}

export default function ContentArea({ title, tabs, activeTab, onTabChange, children }: ContentAreaProps) {
  return (
    <div className="flex-1 flex flex-col">
      {/* Page Header */}
      <div className="border-b border-white/10 bg-[#111010]">
        <div className="px-4 pt-5 pb-3 md:px-8 md:pt-8 md:pb-4">
          <h1 className="text-text-primary font-heading text-2xl md:text-4xl font-bold mb-4 md:mb-6">
            {title}
          </h1>
          
          {/* Horizontal Tabs - scrollable on small screens */}
          <div className="flex gap-1 -mb-px overflow-x-auto scrollbar-none">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              
              return (
                <button
                  key={tab.id}
                  onClick={() => onTabChange(tab.id)}
                  className={`
                    px-4 md:px-6 py-2.5 md:py-3 font-medium text-sm rounded-t-lg transition-all relative whitespace-nowrap shrink-0
                    ${isActive 
                      ? 'text-text-primary bg-[#1a1818]' 
                      : 'text-text-tertiary hover:text-text-secondary hover:bg-white/5'
                    }
                  `}
                >
                  {tab.label}
                  
                  {/* Active Tab Bottom Border */}
                  {isActive && (
                    <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-rollops-primary" />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 bg-[#111010] p-4 md:p-8 overflow-auto scrollbar-styled">
        {children}
      </div>
    </div>
  );
}
